import {useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { appointmentStore } from '../features/appointment/AppointmentSlice';
import Loading from '../Loading';

function Appointment (props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [name, setName] = useState('')
    const [family, setFamily] = useState('')
    const [mobile, setMobile] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const { 
        error,
        loading,
        errorName,
        errorFamily,
        errorMobile,
        errorNationalCode 
    } = useSelector(state => state.appointment)

    const user = {
        'name': name,
        'family': family,
        'mobile': mobile,
        'nationalCode': nationalCode
    }

    const appoinementStoreHandler = () => {
        dispatch(appointmentStore(user));
    }

    return (
        <>
        <div className="row min-vh-100 p-0 m-0 d-flex justify-content-center align-items-start section-left">
            { loading ? ( <Loading /> ) : ''}
            <div className="col-12 col-md-7 d-flex flex-column justify-content-center align-items-center">
                <img className='img-fluid mb-3 mt-0 pt-0' src={props.logo} alt="kavir motor" />
                <div className="mb-5 text-center col-7">
                    <h3>به پرتال مشتریان کویر موتور خوش آمدید</h3>
                    <small className="text-black-50 fw-bold">
                        برای درخواست پیگیری سند غیر حضوری فرم را تکمیل کنید
                    </small>
                </div>
                {/* Appoinetment Form */}
                <div className="col-6">
                    <div>
                    <div className='col-12 mb-3 input'>
                            <input 
                                autoFocus
                                tabIndex="1" 
                                type='text'
                                value={name}
                                onChange={(e) => setName(e.target.value)} 
                                className="form-control form-control-lg shadow-none" 
                                id='exampleInputName' 
                                aria-describedby='nameHelp' 
                                placeholder='نام خود را وارد کنید'
                            />
                            {
                                (errorName) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger'>{ errorName }</small>
                                </span>
                            ):''}
                        </div>
                        <div className='col-12 mb-3 input'>
                            <input 
                                tabIndex="2" 
                                type='text'
                                value={family}
                                onChange={(e) => setFamily(e.target.value)} 
                                className="form-control form-control-lg shadow-none" 
                                id='exampleInputFamily' 
                                aria-describedby='familyHelp' 
                                placeholder='فامیلی خود را وارد کنید'
                            />
                            {
                                (errorFamily) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger'>{ errorFamily }</small>
                                </span>
                            ):''}
                        </div>
                        <div className='col-12 mb-3 input'>
                            <input 
                                tabIndex="3" 
                                type='text'
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)} 
                                className="form-control form-control-lg shadow-none" 
                                id='exampleInputMobile' 
                                aria-describedby='mobileHelp' 
                                placeholder='موبایل خود را وارد کنید'
                            />
                            {
                                (errorMobile) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger'>{ errorMobile }</small>
                                </span>
                            ):''}
                        </div>
                        <div className='col-12 mb-3 input'>
                            <input 
                                tabIndex="4" 
                                type='text'
                                value={nationalCode}
                                onChange={(e) => setNationalCode(e.target.value)} 
                                className="form-control form-control-lg shadow-none" 
                                id='exampleInputNationalCode' 
                                aria-describedby='nationalCodeHelp' 
                                placeholder='کد ملی خود را وارد کنید'
                            />
                            {
                                (errorNationalCode) ? (
                                <span className="help-block  fw-bold d-inline-block mt-2 has-error">
                                    <small className='text-danger'>{ errorNationalCode }</small>
                                </span>
                            ):''}
                        </div>
                        
                        <button 
                            onClick={appoinementStoreHandler}
                            type="submit"
                            className="me-auto px-4 py-2 btn btn-primary">
                            {'  درخواست پیگیری غیرحضوری  '}
                           {
                                (loading) ? (
                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                ) : ''
                            }
                        </button>
                        {
                            (user) ? (
                                error
                            ) : ''
                        }
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Appointment;